/**
 * @generated SignedSource<<3175faa44d55adf198726926971e7535>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageHeader_pageHeader$data = {
  readonly authLink: {
    readonly " $fragmentSpreads": FragmentRefs<"AuthButton_authLink">;
  } | null | undefined;
  readonly pageBackgroundImageUrl: string | null | undefined;
  readonly pageImageOverlayText: string | null | undefined;
  readonly pageImageUrl: string | null | undefined;
  readonly smallHeader: boolean;
  readonly " $fragmentType": "PageHeader_pageHeader";
};
export type PageHeader_pageHeader$key = {
  readonly " $data"?: PageHeader_pageHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageHeader_pageHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageHeader_pageHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageBackgroundImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageImageOverlayText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconLink",
      "kind": "LinkedField",
      "name": "authLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AuthButton_authLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageHeader",
  "abstractKey": null
};

(node as any).hash = "17d5490c40541fec50335125d9b784a8";

export default node;
